import { cn } from '@/lib/utils';

import { ButtonColors, ButtonVariants } from '@/components/atoms/button/index';
import LinkButton from '@/components/atoms/linkButton';
import RichTextFieldSB, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { applyToAllRTFVariants } from '@/components/atoms/richTextField/utils';

import { contactSalesDescriptionStyles } from '@/features/cards/PricingCards/styles';

import {
  cardTitleStyles,
  ctaContainerStyles,
  footnoteStyles,
  priceWrapperStyles,
  pricingCardContainerStyles,
} from './styles';

import IconContactSales from '~/svg/IconContactSales.svg';
import IconMoneyBack from '~/svg/IconMoneyBack.svg';

export type ContactSalesProps = {
  heading?: RichTextFieldStrapiProps['block'];
  icon: React.ReactNode;
  description?: RichTextFieldStrapiProps['block'];
  button: {
    text?: string;
    variant?: ButtonVariants;
    color?: ButtonColors;
    link: string;
  };
  disclaimer?: RichTextFieldStrapiProps['block'];
};

export default function ContactSales({
  heading,
  icon,
  description,
  button,
  disclaimer,
}: ContactSalesProps) {
  const trackId = `ContactUs-pricing-cards`;

  return (
    <div
      data-tracker-component='contact-card'
      className={cn(pricingCardContainerStyles)}
    >
      {heading && (
        <RichTextFieldSB
          block={heading}
          classNames={applyToAllRTFVariants(cardTitleStyles)}
        />
      )}

      <span className={cn(priceWrapperStyles, 'h-auto')}>{icon}</span>
      {description && (
        <RichTextFieldSB
          block={description}
          classNames={applyToAllRTFVariants(contactSalesDescriptionStyles)}
        />
      )}

      <div
        className={ctaContainerStyles}
        data-tracker-component='contact-sales'
      >
        <LinkButton
          data-tracker-context={trackId}
          variant={button.variant || 'outlined'}
          color={button.color || 'primary'}
          href={button.link}
          leftSection={<IconContactSales />}
          slim={false}
          fullwidth
          classNames={{
            inner: 'flex items-center justify-center gap-4',
          }}
        >
          {button?.text}
        </LinkButton>
      </div>
      <div className={footnoteStyles}>
        {disclaimer ? (
          <>
            <IconMoneyBack /> <RichTextFieldSB block={disclaimer} />
          </>
        ) : (
          ' ' // preserves card spacing when disclaimer is disabled
        )}
      </div>
    </div>
  );
}
